import React, { useState, useEffect } from "react";
import * as S from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import { SubmitButton } from "components/Buttons/SubmitButton";
import { CheckBoxOutlined } from "@mui/icons-material";
import CompDropdownMUI from "components/CompDropdownMUI";
import { Button, CircularProgress } from "@mui/material";
import SuccessAlert from "components/Alerts/SuccessAlert";
import FillErrorAlert from "components/Alerts/FillErrorAlert";
import { useNavigate } from "react-router-dom";
import AlertDeleteBenef from "components/Alerts/AlertDeleteBenef";

import * as u from "utils/constants";
const DeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  cancelError,
  cancelErrorDropdown,
  alertType,
  setAlertType,
  isLoading,
  benefitId,
}) => {
  const [justification, setJustification] = useState("");
  const navigate = useNavigate();
  const [closeModalDeleteBenef, setCloseModalDeleteBenef] = useState(false);
  const [openAlertDeleteBenef, setOpenAlertDeleteBenef] = useState(false);

  const Feedback = () => <CircularProgress color="inherit" size="1.5rem" />;

  if (!isOpen) {
    return null;
  }

  const handleJustificationChange = (e) => {
    setJustification(e.target.value);
  };

  const handleConfirm = () => {
    if (justification.length > 0) {
        onConfirm(justification); 
    } else {
        setAlertType("error");
    }
};


  const handleModalDeleteClose = () => {
    setCloseModalDeleteBenef(false);
  };

  const handleAlertDeleteConfirm = async () => {
    setOpenAlertDeleteBenef(true); 
    onConfirm(justification); 
  };


  const ConfirmCancellationBeneficiary = ({
    onClick,
    alertType,
    setAlertType,
  }) => {
    return (
      <SubmitButton
        isLoading={isLoading}
        onClick={onClick}
        alertType={alertType}
        setAlertType={setAlertType}
        buttonText="Confirmar Confirmar exclusão"
        successMsg="Beneficiário cancelado com sucesso."
        errorMsg="Erro ao cancelar o beneficiário."
        startIcon={<CheckBoxOutlined />}
        reload
        sx={{ width: "260px" }}
      />
    );
  };

  return (
    <S.ModalOverlay>
      <S.ModalContent>
        <S.CloseButton onClick={onClose}>
          <CloseIcon />
        </S.CloseButton>
        <S.ModalHeader>
          <S.ModalTitle>Excluir beneficiário</S.ModalTitle>
        </S.ModalHeader>
        <S.ModalBody style={{}}>
          <S.JustificationText>
            JUSTIFICATIVA PARA O EXCLUSÃO DO BENEFICIÁRIO
          </S.JustificationText>
          <S.TextAreaWrapper>
            <S.CustomTextArea
              placeholder="Justifique aqui o motivo da exclusão do beneficiário"
              maxLength={200}
              value={justification}
              onChange={handleJustificationChange}
            />
          </S.TextAreaWrapper>
          {cancelError && <S.ErrorMessage>{cancelError}</S.ErrorMessage>}
          <S.CharLimit>Máximo de 200 caracteres</S.CharLimit>
        </S.ModalBody>
        <S.ModalFooter>
          <Button
            startIcon={<CheckBoxOutlined />}
            variant="contained"
            disabled={justification.length <= 0}
            endIcon={isLoading && <Feedback />}
            sx={{
              backgroundColor: "#88C54B",
              // width: "129px",
              // height: "54px",
              padding: "15px 16px",
              borderRadius: "8px",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 300,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#88C54B",
              },
              color: "#fff",
            }}
            onClick={handleConfirm}
          >
            Confirmar exclusão
          </Button>
         
        </S.ModalFooter>
      </S.ModalContent>


      {openAlertDeleteBenef && ( 
          <AlertDeleteBenef
          onClose={handleModalDeleteClose}
          onConfirm={handleAlertDeleteConfirm} 
        />
        
        )}

      <FillErrorAlert
        open={alertType && alertType === "error"}
        onClose={() => setAlertType("")}
      />
    </S.ModalOverlay>
  );
};

export default DeleteModal;
